import PageBody from "./pageBody";

export default PageBody;
